export default __webpack_public_path__ + "static/media/vlogo.5812ba08.png";